import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Grid, Modal } from "@mui/material";
import { useMediaQuery } from "react-responsive";

import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Footer } from "../../components/Footer/Footer";
import { ReactComponent as IconExpadion } from "./iconExpadion.svg";

function PositivacaoTotalDesktop({ app, config }) {
  const notFullHd = useMediaQuery({ query: "(max-width: 1536px)" });
  const [openModal, setOpenModal] = useState(false);

  return (
    <div className="app positivacao-total">
      <div className="appContent">
        <LayoutWrapper>
          <Grid container className="container-positivacao-total">
            <div className="item-desempenho">
              <Card
                app={app}
                header={{
                  hardTitle: "Desempenho",
                }}
                exportContainer
                exportTable
                exportTableId="JPDsdQ"
                className="card-01"
              >
                <NativeObject
                  app={app}
                  key="JPDsdQ"
                  reference={{ id: "JPDsdQ" }}
                  style={{
                    width: "100%",
                    height: "436px",
                  }}
                />
              </Card>
            </div>
          </Grid>

          <Grid className="container-performance">
            <Card
              app={app}
              header={{
                hardTitle: "Performance",
              }}
              className="card-performance"
              absoluteExpandButton={true}
            >
              {/* <ComboHeader
                legends={[
                  {
                    type: "bar",
                    iconColor: "#CF7F00",
                    name: "Meta",
                  },
                  {
                    type: "bar",
                    iconColor: "#00833C",
                    name: "Realizado",
                  },
                ]}
                className="container-legendas"
              /> */}

              <Button
                className="detail-button"
                variant="outlined"
                onClick={() => setOpenModal(true)}
                endIcon={<IconExpadion />}
              >
                &nbsp;
              </Button>

              <NativeObject
                app={app}
                key="PLvENxL"
                reference={{ id: "PLvENxL" }}
                style={{
                  width: "100%",
                  height: "400px",
                }}
              />
            </Card>
          </Grid>

          <Modal open={openModal} onClose={() => setOpenModal(false)}>
            <Grid
              className="card"
              flexDirection={"column"}
              justifyContent={"center"}
              sx={{
                top: notFullHd ? "52%" : "44%",
                left: notFullHd ? "50%" : "0",
                transform: "translate(-50%, -50%)",
                position: "absolute",
                height: "auto",
                width: notFullHd ? "70%" : "20%",
              }}
            >
              {/* MODAL CONTENT */}
              <Grid
                className="modal-content"
                flexDirection={"column"}
                justifyContent={"flex-start"}
                alignItems={"flex-start"}
                sx={{
                  height: "100%",
                }}
              >
                <NativeObject
                  app={app}
                  key="PLvENxL"
                  reference={{ id: "PLvENxL" }}
                  style={{
                    width: "100%",
                    height: "400px",
                  }}
                />
              </Grid>
            </Grid>
          </Modal>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

PositivacaoTotalDesktop.defaultProps = {
  app: null,
  config: {},
};

PositivacaoTotalDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivacaoTotalDesktop;
